import { render, staticRenderFns } from "./PrevNextLesson.vue?vue&type=template&id=dd901bfe&scoped=true&"
import script from "./PrevNextLesson.vue?vue&type=script&lang=ts&"
export * from "./PrevNextLesson.vue?vue&type=script&lang=ts&"
import style0 from "./PrevNextLesson.vue?vue&type=style&index=0&id=dd901bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd901bfe",
  null
  
)

export default component.exports